/**
 * 리라이트 프록시 접두사 — 브라우저는 백엔드를 `<접두사>/…` 로 부르고 Next 가 그 백엔드로 넘긴다.
 * 키는 `next.config.mjs` 의 `ApiHosts` 키다.
 *
 * ★단일 출처다. 세 곳이 이 값을 같이 쓴다:
 * - `next.config.mjs` `rewrites()` — `<접두사>/:path*` → 그 백엔드
 * - 로케일 미들웨어 `isSystemPath` — 페이지가 아니라 API 호출이라 로케일 307·쿠키 처리를 하지 않는다.
 *   미들웨어는 rewrites 보다 **먼저** 돌아서, 거르지 않으면 `bh_ccode=KR` 사용자의 결제 직전 draft 저장
 *   `PUT` 까지 `307 → /ko/admin-api/…` 를 탄다(docs/locale-middleware-policy.md §1.6)
 * - `backendUrl()`(`src/libs/backend-url.ts`)의 브라우저 갈래 — 서버·브라우저 겸용 호출이 프록시로 갈 때
 *
 * `next.config.mjs` 는 ESM 이라 TS 모듈을 import 하지 못해서 `.mjs` 로 둔다. 프록시를 이 목록을 거치지 않고
 * 설정에 바로 더하면 `__tests__/middleware-proxy-paths.test.ts` 가 빨갛다(설정을 실제로 로드해 대조한다).
 */
export const API_PROXY_PREFIXES = Object.freeze({
  file: "/file-api",
  login: "/login-api",
  sdk: "/sdk-api",
  admin: "/admin-api",
});
